<mat-progress-bar
  mode="indeterminate"
  color="warn"
  [style.display]="loading ? 'block' : 'none'"
/>

<h2 class="m-4"><span class="titulo">Registros</span></h2>

<div class="table-container mat-elevation-z2">
  <!-- Filtro y columnas -->
  <div class="row justify-between align-center" style="padding: 1em">
    <!-- Filtros -->
    <app-filtro-tabla
      class="flex-1"
      [search]="search"
      [datos]="[]"
      (onFilterChange)="cambioFiltro($event)"
    />
    <!-- Columnas -->
    <app-column-select
      [(columns)]="columnas"
      [columnNames]="nombreColumnas"
      [saveName]="saveColumnas"
    />
  </div>

  <mat-paginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />

  <!-- Tabla -->
  <mat-table
    class="responsive"
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortChange($event)"
  >
    <!-- Columna Fecha de Creación  -->
    <ng-container matColumnDef="fechaCreacion">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Fecha de Creación
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Fecha de Creación:</span>
        {{ row.fechaCreacion | date: " dd/MM/yyyy HH:mm:ss" }}
      </mat-cell>
    </ng-container>

    <!-- Columna Código -->
    <ng-container matColumnDef="codigo">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Código </mat-header-cell
      >>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Código:</span>
        <div class="row justify-center align-center">
          <span> {{ row.envioCodigo?.codigo }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Columna nombre -->
    <ng-container matColumnDef="nombre">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Nombre </mat-header-cell
      >>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Nombre:</span>
        <div class="row justify-center align-center">
          <span> {{ row.datosPersonales?.nombre }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Columna DNI -->
    <ng-container matColumnDef="dni">
      <mat-header-cell *matHeaderCellDef mat-sort-header> DNI </mat-header-cell
      >>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">DNI:</span>
        <div class="row justify-center align-center">
          <span> {{ row.datosPersonales?.dni }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Columna Teléfono -->
    <ng-container matColumnDef="telefono">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Teléfono </mat-header-cell
      >>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Teléfono:</span>
        <div class="row justify-center align-center">
          <span> {{ row.datosPersonales?.telefono }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Columna Email -->
    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Email:</span>
        <div
          class="row justify-center align-start"
          style="white-space: normal; word-break: break-word"
        >
          <span>{{ row.datosPersonales?.email }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Columna cliente  -->
    <ng-container matColumnDef="clienteActual">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Cliente actual
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Cliente actual:</span>
        <div class="row justify-center align-center">
          <span> {{ row.cliente?.nombre | titlecase }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Modo -->
    <ng-container matColumnDef="modoRegistro">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Modo de Registro
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Modo de Registro:</span>
        <div class="row justify-center align-center">
          <span>
            {{
              row.dniEscaneado
                ? "DNI"
                : row.creadoPorAdmin
                  ? "Admin"
                  : "Manunal"
            }}</span
          >
        </div>
      </mat-cell>
    </ng-container>

    <!-- Columna Acciones -->
    <ng-container matColumnDef="acciones">
      <mat-header-cell *matHeaderCellDef> Acciones </mat-header-cell>>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Acciones:</span>
        <div>
          <button
            class="mx-1 no-shadow"
            mat-mini-fab
            color="warn"
            matTooltip="Eliminar"
            (click)="eliminar(row)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columnas; sticky: true" />
    <mat-row *matRowDef="let row; columns: columnas" />
  </mat-table>
</div>
